import React from "react";
import "./PhoneNumber/flags/styles.scss";

export const CountryFlagLabel = ({ iso, name }) => {
    if (!iso) return null;
    const code = iso.toUpperCase();
    return (
        <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
            <div className={`flag ${iso}`} />
            {name ? `${name} (${code})` : code}
        </span>
    );
};
